import CookieHelper from '@/helpers/CookieHelper';
import JWTHelper from '@/helpers/JWTHelper';
import SessionStorageHelper from '@/helpers/SessionStorageHelper';
import URLHelper from '@/helpers/URLHelper';

export default class AuthService {
  private readonly restrictedRoutes = [
    { isPartner: true, path: `/connect` },
    { isPartner: true, path: `/equipment` },
    { isPartner: true, path: `/mein-team` },
    { isPartner: true, path: `/meine-termine` },
    { isPartner: true, path: `/prints` },
    { isPartner: true, path: `/products` },
    { isPartner: true, path: `/salestool` },
    { isPartner: true, path: `/statistiken-kundenstatistik` },
    { isPartner: true, path: `/statistiken-teamabfrage` },
    { isPartner: true, path: `/statistiken-umsatzabfrage` },
    { isPartner: true, path: `/umsatzstatistik` },
  ];

  public constructor() {
    const restrictedRoute = this.restrictedRoutes.find(route => new RegExp(`^${route.path}`).test(URLHelper.parseUrl().pathname));

    if(restrictedRoute) {
      const token = CookieHelper.getAuthToken();
      const tokenData = JWTHelper.parseJwt(token);
      if(tokenData && (restrictedRoute.isPartner && tokenData.role !== `partner`)) {
        window.location.href = `/`;
      } else if(!tokenData || (restrictedRoute.isPartner && tokenData.role !== `partner`)) {
        SessionStorageHelper.setRedirect();
        window.location.href = `/login`;
      }
    }
  }
}
